import React from "react";
import { Link } from "react-router-dom";
function Joinus() {
  return (
    <div className="px-4">
      <div className="mx-auto md:px-3 max-w-4xl bg-[#708238] py-12 text-center mb-12 rounded-xl">
        <h3 className="text-2xl lg:text-4xl font-bold text-white leading-snug drop-shadow-lg">
          Unlock Global ERP Opportunities – Join Our Freelancer {" "}
          <span className="text-[#FFA500] font-extrabold">Community!</span>
        </h3>
<Link
  to="/register"
  state={{ from: "hero_cta" }}
>
        <button className="bg-white mt-8 py-2 px-8 rounded-xl hover:bg-[#FFA500] hover:text-white transition-colors duration-300">
          Join Us
        </button>
        </Link>
      </div>
    </div>
  );
}

export default Joinus;
